(function () {
    'use strict';

    angular.module("imApp").factory("fabricsGrpsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1243,
                    parameters: parms || {}
                });
            },
            listFabricGroups: function (parms) {
                return $ihttp.post({
                    method: 1240,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
